export default __webpack_public_path__ + "static/media/nav-logo.10bc8834.svg";